export default __webpack_public_path__ + "static/media/lds-logo_da.ca11481c7606b571.svg";